'use strict';

angular.module('atex.dam').controller('DamLinkToPrintModalController', ['$scope', '$q', 'ContentService',
  'DamTemplateService', 'AuthenticationService', 'DamNotificationService', '$injector',
  'DamStoryContentService',
function($scope, $q, ContentService,
         DamTemplateService, AuthenticationService, DamNotificationService, $injector,
         DamStoryContentService) {
  var ShapeUtils = $injector.get("ShapeUtils");
  var ADMUtils = $injector.get("ADMUtils");
  var PrintService = $injector.get("PrintService");

  var config = atex.onecms.ObjectUtils.getByPath($scope.article, "local/field/config");

  if ( config && config.shapeMode ) {
    $scope.panelTitle = ShapeUtils.getTitle( config.shapeMode );
  } else {
    $scope.panelTitle = '_TEMPLATE_MODAL_PANE_TITLE_';
  }

  $scope.message = ADMUtils.translate('__OPERATION_COMPLETED_SUCCESSFULLY__');
  $scope.additionalPromises = [];
  $scope.loaded = false;
  $scope.showSpinner = true;

  if (!$scope.article)
  {
    $scope.article = atex.Content();
  }

  $scope.user = undefined;

  AuthenticationService.getCurrentUser().then(function(user) {
    var transferInfo = { id: user.userId, variant: 'onecms' };
    ContentService.getContent(transferInfo).then(function(responseInfo) {
      $scope.user = responseInfo.data;
      DamTemplateService.getTemplateByIdAndInputTemplate($scope.type, $scope.inputTemplate).then(function(template){
        $scope.template = angular.copy(template);

        DamStoryContentService.job($scope.article, $scope.storyContentId).then(function () {
          $scope.article.template = $scope.template;
          $scope.loaded = true;
        });
      });
    });
  });

  $scope.hideSpinner = function() {
    $scope.showSpinner = false;
  };

  $scope.isContentId = function(potentialContentId) {
    return typeof potentialContentId === 'string' && potentialContentId.indexOf('contentid/') === 0;
  };

  $scope.$watch("article.local.queryModel", function () {
    if ( $scope.article && $scope.article.local ) {
      var newErrorString = atex.onecms.ObjectUtils.getByPath($scope.article.local, "queryModel/set/errorString");
      var newError = !_.isEmpty(newErrorString);

      if ( newError !== $scope.inError ) {
          $scope.inError = newError;
      }
    }
  }, true);

  $scope.doSave = function() {
    $scope.showSpinner = true;

    var processAddCandidateResults = function (data) {
      if ( data.data.status.lStatusCode === 200 ) {
        DamNotificationService.addNotification(atex.dam.Notification({
          type: 'success',
          message: ADMUtils.translate('__OPERATION_COMPLETED_SUCCESSFULLY__')
        }), false);
        //$scope.showSpinner = false;
        //$scope.$parent.closeModal();
        //$rootScope.$broadcast('dam:updatedItem', $scope.entry);
      } else {
        var message = ADMUtils.translate('__GENERIC_ERROR_MSG__') + " (" + data.data.status.strErrorText + ")";
        DamNotificationService.addNotification(atex.dam.Notification({type: 'error', message: message}), true);
      }

      $scope.showSpinner = false;
      $scope.$parent.closeModal();
    };

    var processAddCandidateError = function (error) {
      $scope.showSpinner = false;
      console.log("processAddCandidateError  error = ", error);
    };

    if ( $scope.article.local && $scope.article.local.shapesObj ) {
      var shapesObj = $scope.article.local.shapesObj;

      if ( shapesObj.shapeMode === ShapeUtils.LINK_TO_PRINT ) {
        var queryModel = $scope.article.local.queryModel;
        var publEvent = ADMUtils.ModelUtils.getPublEvent(queryModel.set );

        PrintService.addCandidate( publEvent ).then(function (data) {
          processAddCandidateResults(data);
        }).then(undefined, function (error) {
          processAddCandidateError(error);
        });
      }
    }
  };

  $scope.changeEndCallback = function(data) {
    $scope.article.data = data;
    $scope.dirty = true;
  };

  $scope.initCallback = function() {
  };

  $scope.changeStartCallback = function() {
  };

  $scope.prepareEdit = function(topDomainObject) {
  };
} ]);
